// extracted by mini-css-extract-plugin
export default {"toolbar":"Header_toolbar__BsYMX","headerTitle":"Header_headerTitle__4GjND","profileName":"Header_profileName__99d2b","profileRole":"Header_profileRole__n3-CE"};